export default __webpack_public_path__ + "static/media/icon-download-gray.7d94e484.svg";